
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("2bQEh", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $c0498ef85235a7fc$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $lAXrD = parcelRequire("lAXrD");
var $c0498ef85235a7fc$export$2e2bcd8739ae039 = (0, $lAXrD.default);

});
parcelRegister("lAXrD", function(module, exports) {

$parcel$export(module.exports, "default", () => $e40ef0a806ba5fcd$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $e40ef0a806ba5fcd$export$2e2bcd8739ae039 = {
    'fabric.atlassianSwitcher.administration': 'Administration',
    'fabric.atlassianSwitcher.analytics': 'Analytics',
    'fabric.atlassianSwitcher.assets': 'Assets',
    'fabric.atlassianSwitcher.atlassianHome': 'Home',
    'fabric.atlassianSwitcher.atlassianWebsiteTryProducts': 'Try Atlassian Products',
    'fabric.atlassianSwitcher.autoProvConfluenceUiUpdateExperimentDescription': 'Document collaboration',
    'fabric.atlassianSwitcher.chat': 'Chat',
    'fabric.atlassianSwitcher.companyHub': 'Company Hub',
    'fabric.atlassianSwitcher.confluenceDescriptionText': 'Document and collaborate',
    'fabric.atlassianSwitcher.confluenceSpace': 'Confluence space',
    'fabric.atlassianSwitcher.contractProductList': 'Less',
    'fabric.atlassianSwitcher.emptyState.exploreProducts.body': 'Try a product to start collaborating with your team.',
    'fabric.atlassianSwitcher.emptyState.exploreProducts.link': 'Explore products',
    'fabric.atlassianSwitcher.emptyState.exploreProducts.title': 'Get started with cloud',
    'fabric.atlassianSwitcher.errorEmptyPartialResults': "We can't display your apps right now.",
    'fabric.atlassianSwitcher.errorFlag.description': "Try again in a few minutes. If you still aren't able to join, <a>contact support</a>.",
    'fabric.atlassianSwitcher.errorFlag.title': "We couldn't add you to {product}",
    'fabric.atlassianSwitcher.errorHeading': "Something\u2019s gone wrong",
    'fabric.atlassianSwitcher.errorHeadingLoggedOut': 'Your Atlassian account is logged out',
    'fabric.atlassianSwitcher.errorHeadingUnverified': 'Your account is unverified',
    'fabric.atlassianSwitcher.errorImageAltText': 'A broken robot and a number of people busy fixing it.',
    'fabric.atlassianSwitcher.errorPartialResults': "We can't display some of your apps right now.",
    'fabric.atlassianSwitcher.errorPartialResultsRefresh': 'Refresh the page, or try again later.',
    'fabric.atlassianSwitcher.errorText': "We keep track of these errors, but feel free to contact us if refreshing doesn\u2019t fix things",
    'fabric.atlassianSwitcher.errorTextLoggedOut': 'Log in again to use the Atlassian switcher.',
    'fabric.atlassianSwitcher.errorTextNetwork': "We couldn\u2019t load this list. Please reload the page and try again.",
    'fabric.atlassianSwitcher.errorTextUnverified': 'Please confirm your email address to view a list of available products.',
    'fabric.atlassianSwitcher.expandProductList': '{numItems} More',
    'fabric.atlassianSwitcher.goals': 'Goals',
    'fabric.atlassianSwitcher.instantAccessStatusText': 'Instant access',
    'fabric.atlassianSwitcher.jiraDescriptionText': 'Plan and track project delivery',
    'fabric.atlassianSwitcher.jiraProject': 'Jira project',
    'fabric.atlassianSwitcher.join': 'Join',
    'fabric.atlassianSwitcher.joinStatusText': 'Join',
    'fabric.atlassianSwitcher.joinTeamStatusText': 'Join team',
    'fabric.atlassianSwitcher.jpdDescriptionText': 'Prioritize and plan new ideas',
    'fabric.atlassianSwitcher.jsmDescriptionText': 'Automate and deliver IT support',
    'fabric.atlassianSwitcher.jwmInactiveSwitcherWithDefaultItemDescription': 'Manage projects for business teams',
    'fabric.atlassianSwitcher.jwmInactiveSwitcherWithJSWItemDescription': 'Manage business projects, free with Jira Software',
    'fabric.atlassianSwitcher.login': 'Log in',
    'fabric.atlassianSwitcher.manageList': 'Manage list',
    'fabric.atlassianSwitcher.modalLabel': 'Atlassian App Switcher',
    'fabric.atlassianSwitcher.more': 'More',
    'fabric.atlassianSwitcher.moveItemDown': 'Move down',
    'fabric.atlassianSwitcher.moveItemToBottom': 'Move to bottom',
    'fabric.atlassianSwitcher.moveItemToTop': 'Move to top',
    'fabric.atlassianSwitcher.moveItemUp': 'Move up',
    'fabric.atlassianSwitcher.newLozenge': 'New',
    'fabric.atlassianSwitcher.organisationsLabel': 'Organizations',
    'fabric.atlassianSwitcher.product.description.compass': 'Component manager',
    'fabric.atlassianSwitcher.product.description.confluence': 'Document collaboration',
    'fabric.atlassianSwitcher.product.description.jsm': 'Collaborative IT service management',
    'fabric.atlassianSwitcher.product.description.jsw': 'Project and issue tracking',
    'fabric.atlassianSwitcher.product.description.opsgenie': 'Modern incident management',
    'fabric.atlassianSwitcher.reorderItemDropdown': 'Reorder menu item',
    'fabric.atlassianSwitcher.reorderItemErrorFlagAction': 'Got it',
    'fabric.atlassianSwitcher.reorderItemErrorFlagDescription': 'Please refresh the page or try again later.',
    'fabric.atlassianSwitcher.reorderItemErrorFlagTitle': 'Something went wrong',
    'fabric.atlassianSwitcher.requestAccessStatusText': 'Request access',
    'fabric.atlassianSwitcher.requestSentStatusText': 'Request sent',
    'fabric.atlassianSwitcher.resizeBarLabel': 'Resize app switcher',
    'fabric.atlassianSwitcher.resizeBarTooltipCollapsed': 'Drag to resize{separator}Press to expand',
    'fabric.atlassianSwitcher.resizeBarTooltipExpanded': 'Drag to resize{separator}Press to collapse',
    'fabric.atlassianSwitcher.resizeBarValueTextLabel': 'Width',
    'fabric.atlassianSwitcher.search': 'Search',
    'fabric.atlassianSwitcher.sites': '{productName} {numSites, plural, one {site} other {sites}}',
    'fabric.atlassianSwitcher.skeletonLoaderAriaLabel': 'The App Switcher is loading',
    'fabric.atlassianSwitcher.start': 'Atlassian Start',
    'fabric.atlassianSwitcher.startAriaLabel': 'Atlassian Start opens in a new tab',
    'fabric.atlassianSwitcher.studio': 'Studio',
    'fabric.atlassianSwitcher.successFlag.description': "You'll get an email once it's approved",
    'fabric.atlassianSwitcher.successFlag.title': 'Access request sent to Admin',
    'fabric.atlassianSwitcher.switchSitesOrAppsTooltip': 'Switch sites or apps',
    'fabric.atlassianSwitcher.switchTo': 'Switch to',
    'fabric.atlassianSwitcher.switchToTooltip': "Switch to\u2026",
    'fabric.atlassianSwitcher.teams': 'Teams',
    'fabric.atlassianSwitcher.tryLozenge': 'Try',
    'fabric.atlassianSwitcher.yourApps': 'Your apps',
    'fabric.atlassianSwitcher.yourAppsTooltip': "Your apps\u2026"
};

});



//# sourceMappingURL=@atlaskit-internal_async-atlassian-switcher-i18n-en.e1b40fe2.js.map
